/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createPaginatedListOfDocumentSummaryFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type ContractDocumentType, type PaginatedListOfDocumentSummary, type ProblemDetails } from '../../../models/index.js';
// @ts-ignore
import { MultipartBody, serializeMultipartBody, type BaseRequestBuilder, type Guid, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /customers/{customer-id}/documents
 */
export interface DocumentsRequestBuilder extends BaseRequestBuilder<DocumentsRequestBuilder> {
    /**
     * GetDocumentsByCustomer
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PaginatedListOfDocumentSummary>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<DocumentsRequestBuilderGetQueryParameters> | undefined) : Promise<PaginatedListOfDocumentSummary | undefined>;
    /**
     * CreateDocument
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Guid>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     post(body: MultipartBody, requestConfiguration?: RequestConfiguration<DocumentsRequestBuilderPostQueryParameters> | undefined) : Promise<Guid | undefined>;
    /**
     * GetDocumentsByCustomer
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<DocumentsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * CreateDocument
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: MultipartBody, requestConfiguration?: RequestConfiguration<DocumentsRequestBuilderPostQueryParameters> | undefined) : RequestInformation;
}
/**
 * GetDocumentsByCustomer
 */
export interface DocumentsRequestBuilderGetQueryParameters {
    pageNumber?: number;
    pageSize?: number;
}
/**
 * CreateDocument
 */
export interface DocumentsRequestBuilderPostQueryParameters {
    chargePointId?: Guid;
    contractId?: Guid;
    locationId?: Guid;
    type?: ContractDocumentType;
}
/**
 * Uri template for the request builder.
 */
export const DocumentsRequestBuilderUriTemplate = "{+baseurl}/customers/{customer%2Did}/documents{?PageNumber*,PageSize*,chargePointId*,contractId*,locationId*}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const DocumentsRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "pageNumber": "PageNumber",
    "pageSize": "PageSize",
};
/**
 * Metadata for all the requests in the request builder.
 */
export const DocumentsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: DocumentsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPaginatedListOfDocumentSummaryFromDiscriminatorValue,
        queryParametersMapper: DocumentsRequestBuilderGetQueryParametersMapper,
    },
    post: {
        uriTemplate: "{+baseurl}/customers/{customer%2Did}/documents?type={type}{&chargePointId*,contractId*,locationId*}",
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "string",
        requestBodyContentType: "multipart/form-data",
        requestBodySerializer: serializeMultipartBody,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
